"use strict";

// 构成「一次登录会话」的键集合。
// 单端共享：只需 routes 源 + 身份键；overlay 键不入快照（bootstrap 从 routes 重建插件深链）。
var SNAPSHOT_KEYS = [
  "token",
  "routes",
  "userinfo",
  "guardName",
  "shopid",
  "storeid",
  "accountScope",
  "regionContext",
  "currentRegionStoreId",
  "loginPage",
  "isApply",
  "IMtoken",
];

// 登录态切换时需要一并清理的运行态键，避免跨端账号残留旧身份或插件路由。
var CLEAR_SESSION_KEYS = SNAPSHOT_KEYS.concat([
  "routestext",
  "routesOld",
  "pluginroute",
  "pluginid",
  "is_plugin",
  "pluginmatch",
  "pluginskipreconstruct",
  "role_id",
]);

var SNAPSHOT_VERSION = 1; // schema 变更时 +1，旧快照将被 decode 丢弃
// 兜底上限：仅当 token 不是可解析 JWT（无 exp）时才用。正常 JWT 走自带 exp（各端 TTL 自适配）。
var SNAPSHOT_MAX_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 天，覆盖后端最长端 user_ttl

// 从 storage（getItem 接口）抽出会话数据；无 token 视为未登录 -> null
function pickSnapshotData(storage) {
  var token = storage.getItem("token");
  if (!token) return null;
  var data = {};
  for (var i = 0; i < SNAPSHOT_KEYS.length; i++) {
    var k = SNAPSHOT_KEYS[i];
    var v = storage.getItem(k);
    if (v !== null && v !== undefined) data[k] = v;
  }
  return data;
}

// 序列化为持久化字符串（带版本 + 时间戳）
function encodeSnapshot(data, nowMs) {
  return JSON.stringify({ v: SNAPSHOT_VERSION, savedAt: nowMs, data: data });
}

// 读 JWT payload 的 exp（秒）-> 毫秒；非 JWT/无 exp/解析失败 -> null。
// 仅用于客户端「别恢复已过期 token」，不做签名校验（后端仍会校验）。浏览器用 atob，Node 测试回退 Buffer。
function decodeJwtExpMs(token) {
  if (typeof token !== "string") return null;
  var parts = token.split(".");
  if (parts.length < 3) return null; // 标准 JWT 必须 header.payload.signature 三段
  var s = parts[1].replace(/-/g, "+").replace(/_/g, "/");
  while (s.length % 4) s += "=";
  try {
    var json;
    if (typeof atob === "function") {
      json = atob(s);
    } else if (typeof globalThis !== "undefined" && globalThis.Buffer) {
      json = globalThis.Buffer.from(s, "base64").toString("binary");
    } else {
      return null;
    }
    var payload = JSON.parse(json);
    if (typeof payload.exp !== "number") return null;
    return payload.exp * 1000;
  } catch (e) {
    return null;
  }
}

// 解析 + 校验：版本 / token / routes 结构 + 过期。任一不过 -> null
// 过期优先用 token 自带 JWT exp（各端 TTL 自适配）；token 非 JWT 时回退 savedAt + fallbackTtlMs。
function decodeSnapshot(raw, nowMs, fallbackTtlMs) {
  if (!raw) return null;
  var obj;
  try {
    obj = JSON.parse(raw);
  } catch (e) {
    return null;
  }
  if (!obj || obj.v !== SNAPSHOT_VERSION) return null;
  if (typeof obj.savedAt !== "number") return null;
  var data = obj.data;
  if (!data || typeof data.token !== "string" || data.token === "") return null;
  if (typeof data.routes !== "string") return null; // routes 源缺失 -> 守卫会判未登录
  try {
    JSON.parse(data.routes); // routes 必须是合法 JSON
  } catch (e) {
    return null;
  }
  var expMs = decodeJwtExpMs(data.token);
  if (expMs !== null) {
    if (nowMs >= expMs) return null; // JWT 已过期
  } else if (fallbackTtlMs > 0 && nowMs - obj.savedAt > fallbackTtlMs) {
    return null; // 非 JWT 兜底
  }
  return data;
}

// 把会话数据写回 storage（setItem 接口）
function writeSnapshotData(storage, data) {
  for (var k in data) {
    if (Object.prototype.hasOwnProperty.call(data, k)) storage.setItem(k, data[k]);
  }
}

// 清理一次登录会话涉及的 sessionStorage 键；普通门店登录前必须移除区域身份键。
function clearAuthSessionData(storage) {
  if (!storage || typeof storage.removeItem !== "function") return;
  for (var i = 0; i < CLEAR_SESSION_KEYS.length; i++) {
    storage.removeItem(CLEAR_SESSION_KEYS[i]);
  }
}

module.exports = {
  SNAPSHOT_KEYS: SNAPSHOT_KEYS,
  CLEAR_SESSION_KEYS: CLEAR_SESSION_KEYS,
  SNAPSHOT_VERSION: SNAPSHOT_VERSION,
  SNAPSHOT_MAX_TTL_MS: SNAPSHOT_MAX_TTL_MS,
  pickSnapshotData: pickSnapshotData,
  encodeSnapshot: encodeSnapshot,
  decodeJwtExpMs: decodeJwtExpMs,
  decodeSnapshot: decodeSnapshot,
  writeSnapshotData: writeSnapshotData,
  clearAuthSessionData: clearAuthSessionData,
};
